export default function SiengePlanStatus(){return <aside className="director-cost-plan__notice"><h2>Orçamento Empresarial Sienge</h2><p>Aguardando integração e liberação. A fonte Sienge ainda não pode ser aplicada.</p></aside>;}
